<template>
  <div class="jersey-numbers-style">
    <div
      v-for="option in options"
      :key="option.value"
      :class="{
        'jersey-numbers-style__item': true,
        'jersey-numbers-style__item--selected': option.value === letterNumberArtwork.style
      }"
      data-testid="transfers-number-style-item"
      @click="handleSelect(option)"
    >
      <div
        :class="{
          'jersey-numbers-style__text': true,
          [`jersey-numbers-style__text--${option.value}`]: true
        }"
      >
        12345<br />67890
      </div>
      <span class="jersey-numbers-style__label">{{ option.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { calculateSizes } from "components/jiffy/vue-product-details-dtf/JerseyNumbers/utils";
import { useDtfStore } from "../store";

const options = [
  { label: "Solid Numbers", value: "solid" },
  { label: "Outline Numbers", value: "outline" },
  { label: "Promesh", value: "promesh" },
  { label: "Soccer League", value: "soccer-league" },
  { label: "Octin Sports", value: "octin-sports" },
  { label: "Rueckwarzsalto", value: "rueckwarzsalto" },
  { label: "Varsity Team", value: "varsity-team" }
];

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);

const handleSelect = option => {
  const style = option.value;
  const sizes = calculateSizes({ ...letterNumberArtwork.value, style });
  store.updateArtworkValues({ index: 0, style, sizes });
  if (Object.keys(sizes).length) {
    store.getArtworksPricing();
  }
  store.updateJerseyNumberPdpDates();
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.jersey-numbers-style {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: auto;

  @include with-desktop {
    flex-wrap: wrap;
    overflow-x: unset;
  }

  &__item {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    border-radius: 8px;
    border: 1px solid $gray-label;
    padding: 16px;
    text-align: center;
    cursor: pointer;
    min-width: 140px;
    height: 150px;

    &--selected {
      border-radius: 8px;
      border: 2px solid $primary-600;
      padding: 15px;
    }
  }

  &__label {
    color: $text-black;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
  }

  &__text {
    font-size: 28px;

    $font-families: (
      "solid": "Emilio 19",
      "outline": "Emilio 20",
      "promesh": "Promesh",
      "niconne": "Niconne",
      "squares-bold": "Squares Bold",
      "beantown": "Beantown",
      "octin-sports": "Oction Sports",
      "soccer-league": "Soccer League",
      "rueckwarzsalto": "Rueckwarzsalto",
      "facon": "Facon",
      "varsity-team": "Varsity Team"
    );

    @each $modifier, $font-family in $font-families {
      &--#{$modifier} {
        font-family: quote(#{$font-family});
      }
    }
  }
}
</style>
